import Vue from 'vue'
import Cookies from 'js-cookie'
import Element from 'element-ui'

import App from './App.vue'
import store from './store'
import router from './router'

import axios from 'axios'

import 'normalize.css'
import '@/styles/element-variables.scss'
import '@/styles/index.scss'

Vue.use(Element, { size: Cookies.get('size') || 'medium' })

import '@/icons'
import '@/router/guards'
import '@/utils/error-log'

import 'babel-polyfill';
import Mgr from './services/SecurityService'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

const user = new Mgr()


const memberSystem = axios.create({
  baseURL: process.env.VUE_APP_GATEWAY_BASE_URL + '/member/api',   
  timeout: 50000
})

const productSystem = axios.create({
  //baseURL: process.env.VUE_APP_GATEWAY_BASE_URL + '/product/api', 
  baseURL: process.env.VUE_APP_GATEWAY_PBASE_URL + '/product/api',
  timeout: 50000
})

memberSystem.interceptors.response.use(success => {
  console.log('请求响应拦截器', success);
  //alert('请求响应拦截器');
  //this.$message.error('请求响应拦截器');
  if (success.status !== 200) {
    Element.Message('网络请求异常:' + "请重试或联系管理员");
    return
  }

  return success;
}, err => {
  console.log('网络请求异常日志:', err);
  Element.Message('网络请求异常:' + err)
});

class WebRequest {

  async defineHeaderAxios() {
    await user.getAcessToken().then(
      acessToken => {
        memberSystem.defaults.headers.common['Authorization'] = 'Bearer ' + acessToken
      }, err => {
        console.log('err', err)
      })

  }

  async post(url, data) {

    //console.log("当前页面地址:",window.location.href);
    localStorage.setItem("ids_redirect_url", window.location.href);
    await this.defineHeaderAxios();

    if (data == null || data == undefined) {
      return await memberSystem.post(url);
    } else {
      return await memberSystem.post(url, data);
    }

  }
}

class PWebRequest {

  async defineHeaderAxios() {
    await user.getAcessToken().then(
      acessToken => {
        productSystem.defaults.headers.common['Authorization'] = 'Bearer ' + acessToken
      }, err => {
        console.log('err', err)
      })

  }

  async post(url, data) {

    await this.defineHeaderAxios();

    if (data == null || data == undefined) {
      return await productSystem.post(url);
    } else {
      return await productSystem.post(url, data);
    }

  }
}

//Vue.prototype.$http = memberSystem
//Vue.prototype.$pHttp = productSystem
Vue.prototype.$http = new WebRequest()
Vue.prototype.$pHttp = new PWebRequest()
Vue.prototype.$axios = axios;

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')


router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    user.getRole().then(
      sucess => {
        if (to.meta.role == sucess) {
          next();
        } else {
          next('/accessdenied');
        }
      },
      err => {
        console.log(err);
      }
    );
  } else {
    next();
  }
});

export default {
  user: user
}